export function index(withHasJobsOrHasApplications = false)
{
    const includes = withHasJobsOrHasApplications ? '&include[jobs]&include[applications]' : '';
    return axios.get(route('api.manage.companies.tags') + '?limit=999' + includes)
        .then(response => response.data);
}

export function indexHasCompetences()
{
    return axios.get(route('api.manage.companies.tags') + '?limit=999&filter[has_competences]')
        .then(response => response.data);
}

export function store(data)
{
    return axios.post(route('api.manage.companies.tags'), data)
        .then(response => response.data);
}

export function show(tagId)
{
    return axios.get(route('api.manage.tags.show', { tagId: tagId }));
}

export function update(tagId, data)
{
    return axios.patch(route('api.manage.tags.update', { tagId: tagId }), data)
        .then(response => response.data);
}

export function destroy(tagId)
{
    return axios.delete(route('api.manage.tags.destroy', { tagId: tagId }));
}
